// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3mdkx","header":"MergedInvoice_header__350jq"};